/* 📡 shared "which market is actually locked for trading" channel — the
   signal scanner publishes here so the live digit tape always streams the
   EXACT pair the next contract fires on. */
let cur = { sym: "1HZ100V", label: "V100 1s" };
const subs = new Set();

export const setLiveMarket = (sym, label) => {
  if (!sym || cur.sym === sym) return;
  cur = { sym, label: label || sym };
  subs.forEach((f) => { try { f(cur); } catch { /* listener error */ } });
};

export const getLiveMarket = () => cur;

export const onLiveMarket = (f) => {
  subs.add(f);
  return () => subs.delete(f);
};
